export const CHECKOUT_URL = 'https://daycare-os.impultienda.ar/checkout';

export const META_PIXEL_ID = '1033340649567929';

export const SUPPORT_EMAIL = '[SUPPORT_EMAIL]';

export const PRODUCT_NAME = 'The Daycare Operating System™';

export const PRICE = '$27';

export const REGULAR_PRICE = '$97';

export const TOTAL_VALUE = '$361';

export const SEO = {
  title:
    'The Daycare Operating System™ — The 6-Volume Operating Manual for Home Daycare Providers',
  description:
    'Launching full, filling every seat, keeping staff and families, inspection-ready paperwork, rates and daily operations — the complete written system that runs a home daycare or small child care center. 6 volumes, 200+ pages, 28 printable forms, 60+ word-for-word scripts. $27.',
};
